import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from "@angular/router";
import { Output, EventEmitter } from '@angular/core';
import { CommonService } from '../../../services/common.service';
import { ArticlesService } from '../../../services/articles.service';
import { AuthenticationService } from '../../../services/authentication.service';

@Component({
    selector: 'app-articles-box',
    templateUrl: './articles-box.component.html',
    styleUrls: ['./articles-box.component.scss']
})
export class ArticlesBoxComponent implements OnInit {

    @Input() isUserArticles: boolean = false;

    @Input() userId: string = "";

    @Input() title: string = "latest articles";

    constructor(private authentication: AuthenticationService, private _router: Router, private _commonService: CommonService, private _articlesService: ArticlesService) { }

    public headerBtn = false;

    ngOnInit(): void {
        if (!this.isUserArticles)
            this.getArticles();
        else
            this.getUserArticles(1);
    }

    articles: any[] = [];

    getArticles() {
        this._articlesService.getArticles(1).subscribe(
            (res: any) => {
                if (res.success) {
                    if (res.data != null)
                        this.articles = res.data;
                }
            },
            (err: any) => {
                console.error("Web/ArticlesBox/getArticles()", err);
            }
        );
    }
    getUserArticles(page: any) {

        this._articlesService.getUserArticles(page, this.userId).subscribe(
            (res: any) => {

                if (res.data != null) {
                    for (var i = 0; i < res.data.length; i++) {
                        this.articles.push({
                            id: res.data[i].id,
                            title: res.data[i].title,
                            source: res.data[i].source,
                            navigateType: res.data[i].navigateType,
                            createdDate: res.data[i].createdDate,
                            authorName: res.data[i].authorName,
                            status: res.data[i].status,
                            publishedDate: res.data[i].publishedDate,
                            navigateUrl: res.data[i].navigateUrl
                        });
                    }

                    if (res.data.length > 0)
                        this.getUserArticles(page + 1);
                }
            },
            (err: any) => { }
        );
    }

    openArticle(id: any) {
        this._router.navigate(['articles/detail/' + id])
    }

    openSubmitArticle() {
        this._router.navigate(['articles/create']);
    }
    openArticles() {
        this._router.navigate(['articles/all']);
    }

}
